import React from "react";
import styled from "styled-components";

/**
 * Section 2: a single white band of letterspaced trust signals separated by
 * hairline rules, with a green dot on the first item. Ported from the reference's
 * Tailwind classes (see Hero.styles.ts for the px-not-rem note).
 */
const Wrapper = styled.section`
  position: relative;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: #fff;

  .signals {
    margin: 0 auto;
    max-width: 1152px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    column-gap: 32px;
    row-gap: 12px;
    padding: 20px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.18em;
    color: rgba(14, 17, 22, 0.6);
  }

  .signal {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* The separator is a pseudo-element of the signal that follows it rather than
   * a flex item of its own: as a sibling it wrapped independently and left a
   * hairline dangling at the end of a line with its signal on the next one.
   * 24px + the .signal gap of 8px reproduces the 32px column-gap it used to sit in. */
  .signal + .signal::before {
    content: "";
    width: 1px;
    height: 16px;
    margin-right: 24px;
    background: rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 999px;
    background: var(--brand-green);
    flex-shrink: 0;
  }

  @media screen and (min-width: 640px) {
    .signals {
      padding: 20px 32px;
      font-size: 14px;
    }
  }
`;

const TrustBar = ({ signals }: { signals: string[] }) => {
  return (
    <Wrapper className="section-lp-trust">
      <div className="signals">
        {signals.map((signal, i) => (
          <span className="signal" key={signal}>
            {i === 0 ? <span className="dot" /> : null}
            {signal}
          </span>
        ))}
      </div>
    </Wrapper>
  );
};

export default TrustBar;
